const en = {
  nav: {
    home: 'Home',
    artisanBreads: 'Artisan Bread',
    portfolio: 'Portfolio',
    gallery: 'Galerie',
    shop: 'Shop',
    contact: 'Contact',
  },
  imageStrip: {
    freshFromOven: 'Fresh from the oven',
    breadTable: 'The bread table',
  },
  gallery: {
    all: 'All',
    breads: 'Breads',
    foodDrinks: 'Food & drinks',
      catering: 'Catering',
      kozunak: 'Kozunak',
  },
  menu: {
    bar: 'Bar',
    barSubtitle: 'Cocktails and more',
    catering: 'Snacks',
    cateringSubtitle: 'Berlin',
    artisanBreads: 'Homemade Artisan Bread',
    artisanBreadsSubtitle: 'Bread & pastries',
    hotDrinks: 'Hot Drinks',
    hotDrinksSubtitle: 'Coffee fantasies',
    desserts: 'Desserts',
    dessertsSubtitle: 'Cakes and pastry',
  },
  pages: {
    menu: {
      heroLabel: 'Menu',
      heroTitle: 'Food & drinks',
      heroText: 'Homemade food, warm drinks, and artisan bread made with care.',
      heroPassion: 'True Passion',
      heroFlavours: 'Natural Flavours',
      introLabel: 'Grain Bites',
      introTitle: 'Choose your favourite',
      introText: 'Simple ingredients, generous portions, and something good for every mood.',
      showcaseTitle: 'Delicious menu',
      showcaseText: 'Best offers from the Grain Bites kitchen',
      menuItem: 'Menu item',
      barTitle: 'Bar & Snacks',
      coffeeTitle: 'Coffee',
      teaTitle: 'Tea',
      dessertsTitle: 'Desserts',
      viewAll: 'View all',
      openMenu: 'Open',
      openDetails: 'Open details for',
      close: 'Close details',
      ingredientsLabel: 'Ingredients',
      descriptions: {
        bar: 'Carefully prepared drinks and small bites for a relaxed moment.',
        coffee: 'Warm coffee favourites prepared with care for every kind of day.',
        tea: 'A selection of aromatic teas, served warm and ready to enjoy.',
        desserts: 'Freshly prepared sweet treats for a gentle finish.',
      },
      featured: {
        breakfastTitle: 'Breakfast menu',
        breakfastText: 'Fresh starts from 8:00am–12:00pm',
        lunchTitle: 'Lunch menu',
        lunchText: 'Good food for an easy midday break',
      },
      columns: {
        breakfast: 'Breakfast',
        lunch: 'Lunch',
      },
      items: {
        morningEggToast: 'Morning egg toast',
        breakfastPlate: 'Breakfast plate',
        sweetKozunak: 'Sweet kozunak',
        seasonalPlate: 'Seasonal plate',
        grainBowl: 'Grain bowl',
        sharedTable: 'Shared table',
        warmLunchPlate: 'Warm lunch plate',
        sweetFinish: 'Sweet finish',
      },
      ingredients: {
        morningEggToast: 'Sourdough / egg / butter / seasonal greens',
        breakfastPlate: 'Eggs / sourdough / greens / herbs',
        sweetKozunak: 'Egg / butter / citrus / wheat flour',
        seasonalPlate: 'Fresh vegetables / herbs / house dressing',
        grainBowl: 'Grains / greens / roasted vegetables',
        sharedTable: 'Bread / dips / vegetables / herbs',
        warmLunchPlate: 'Grains / roasted vegetables / herbs',
        sweetFinish: 'Fresh fruit / pastry / house cream',
      },
    },
    contact: {
      eyebrow: 'Grain Bites',
      title: 'Contact',
      intro: "Let's talk about your next event, menu, or catering idea.",
      sectionLabel: 'Find us',
      heading: 'Come and say hello',
      description: 'We would love to hear from you and help shape something delicious.',
      sendLabel: 'Send a message',
      formTitle: 'Tell us what you need',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send message',
      sending: 'Sending...',
      success: 'Thanks — your message was sent.',
      error: 'We could not send your message. Please try again.',
    },
    blogPost: {
      label: 'Grain Bites journal',
      title: 'Why sourdough needs time',
      intro: 'A closer look at fermentation, flavour, and the craft behind every loaf.',
      overviewTitle: 'Why sourdough needs time',
      overviewIntro: 'A closer look at fermentation, flavour, and the craft behind every loaf.',
      basicsTitle: 'What is sourdough?',
      basicsIntro: 'Discover how flour, water, wild yeast, and time become bread with character.',
      benefitsTitle: 'The benefits of sourdough',
      benefitsIntro: 'Why naturally fermented bread is full of flavour and easier to enjoy.',
      processTitle: 'From starter to crust',
      processIntro: 'The patient steps that turn a lively starter into a loaf with a golden crust.',
      back: 'Back to the journal',
      notFound: 'This story could not be found.',
      published: 'Published',
      contentsFermentation: 'Fermentation creates character',
      contentsCrust: 'From starter to crust',
      categoryBread: 'Artisan bread',
      categorySourdough: 'Sourdough',
      categoryTea: 'Tea & moments',
      categoryMenu: 'Food & drinks',
      fermentationTitle: 'Fermentation creates character',
      fermentationIntro: 'How a slow fermentation gives sourdough its aroma, structure, and depth.',
      crustTitle: 'From starter to crust',
      crustIntro: 'The patient steps that turn a lively starter into a loaf with a golden crust.',
      contentsFermentationHow: 'How fermentation works',
      contentsFermentationTime: 'Time and temperature',
      contentsCrustStarter: 'Refreshing the starter',
      contentsCrustBake: 'Baking the loaf',
      overviewContentsTrend: 'More than a trend',
      overviewContentsWhat: 'What is sourdough?',
      overviewContentsBenefits: 'Benefits of sourdough',
      overviewContentsCrust: 'From starter to crust',
      contentsBasicsWhat: 'What is sourdough?',
      contentsBasicsTrend: 'Why it matters',
      contentsBenefitsCharacter: 'Flavour and character',
      contentsProcessPatience: 'Patience in the process',
      contentsProcessBake: 'From dough to crust',
    },
    artisanBreads: {
      eyebrow: 'Grain Bites',
      title: 'Homemade Artisan Bread & Pastries',
      intro: 'Homemade artisan bread and fresh pastries made with simple ingredients, careful hands, and time.',
      tagline: 'From live sourdough to a golden crust',
      sectionLabel: 'Fresh from the oven',
      heading: 'Good bread takes time',
      description: 'Our artisan bread selection is made for generous tables, relaxed mornings, and memorable gatherings. Every loaf is prepared with care and served fresh.',
      sourdoughTitle: 'Sourdough baking is more than just a trend',
      sourdoughIntro: 'It is a return to a centuries-old craft. When you bake your own bread with sourdough, you experience not only the incomparable aroma of freshly baked bread, but also many health benefits and a unique taste experience.',
      sourdoughLabel: 'Sourdough',
      sourdoughWhatTitle: 'What is sourdough?',
      sourdoughWhatText: 'Sourdough is a natural mixture of flour and water that ferments through lactic acid bacteria and wild yeasts. This fermentation process makes the bread rise naturally – without artificial raising agents. The long resting time develops deep flavours and a particularly easy-to-digest crumb.',
      sourdoughBenefitsTitle: 'Benefits of sourdough bread',
      sourdoughBenefits: [
        'Natural shelf life: Sourdough acts as a natural preservative, keeping your bread fresh for longer.',
        'Better digestibility: The breakdown of phytic acid makes sourdough bread easier to digest and more nutrient-rich.',
        'Unique taste: A combination of mild and lightly sour notes makes every loaf an aromatic pleasure.',
        'Healthy ingredients: No additives and no industrial yeast – only flour, water, salt, and time.',
      ],
      sourdoughCtaTitle: 'Discover the world of sourdough',
      sourdoughCtaText: 'Learn how a simple flour-and-water starter becomes bread with depth, aroma, and character.',
      sourdoughCtaLink: 'Explore sourdough',
      sourdoughPageTitle: 'The Sourdough Guide',
      sourdoughPageIntro: 'A closer look at fermentation, flavour, and the craft behind every loaf.',
      sourdoughBack: 'Back to artisan bread',
      sourdoughTopicsLabel: 'Sourdough topics',
      sourdoughTopics: {
        overview: 'Sourdough',
        basics: 'What is sourdough?',
        benefits: 'Benefits',
        process: 'From starter to crust',
      },
      slowPreparation: 'Slow preparation',
      slowPreparationText: 'Time for texture and flavour.',
      madeForSharing: 'Made for sharing',
      madeForSharingText: 'Perfect for breakfast and catering.',
      planOrder: 'Plan an order',
      collection: 'The collection',
      galleryTitle: 'Baked for sharing',
      viewDetails: 'View details',
      close: 'Close product details',
      ingredients: 'Ingredients',
      categories: {
        wholegrain: 'Wholegrain',
        white: 'White',
        goldenGrain: 'Golden Grain',
        dinkel: 'Dinkel',
        mixes: 'Mixes',
        dinkelRye: 'Dinkel-Roggen',
        kozunak: 'Kozunak',
      },
    },
    portfolio: {
      eyebrow: 'Grain Bites',
      title: 'Portfolio',
      introHeading: 'A selection of our work',
      introText: 'Bars, catering tables, artisan bread, and events shaped with care in the spirit of Kreuzberg.',
      projects: {
        bar: {
          label: 'Bar & drinks',
          title: 'Cocktailbar experiences',
          text: 'A relaxed bar atmosphere with thoughtful drinks, warm service, and a setting made for good conversations.',
          imageAlt: 'Grain Bites bar atmosphere',
        },
        catering: {
          label: 'Catering',
          title: 'Tables made for sharing',
          text: 'From business lunches to private celebrations, we create generous tables that bring people together around fresh food.',
          imageAlt: 'A Grain Bites catering table',
        },
        bread: {
          label: 'Artisan bread',
          title: 'Fresh from the oven',
          text: 'Homemade breads and pastries add a warm, memorable centrepiece to every menu and event.',
          imageAlt: 'Fresh artisan bread',
        },
        events: {
          label: 'Events',
          title: 'Food with a sense of place',
          text: 'We shape each event around its people, its space, and the small details that make the experience feel personal.',
          imageAlt: 'A Grain Bites event space',
        },
      },
    },
  },
};

export default en;
